<template>
  <div v-if="year" style="width:100%;">
    <v-menu ref="menu1" v-model="dateMenu" width="100%" :close-on-content-click="false" transition="scale-transition" offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-row class="align-center d-flex">
          <v-btn v-if="showOneClick" outlined color="btn_outline" class="outlined-btn" large width="92" @click="dateHandler('current', 'year')">
            <div class="d-flex align-center" style="gap:8px">
              <svg-icon icon-class="history" class="btn_text--text" />
              <span style="font-size:1rem" class="main_text--text">금년</span>
            </div>
          </v-btn>
          <v-btn icon @click="dateHandler('previous', 'year')">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-text-field
            :style="mobileTrigger ? 'width:40%' : 'width:20%'"
            v-model="displayDate"
            append-icon="$calendar"
            v-bind="attrs"
            v-on="on"
            readonly
            solo
            class="editor_bg"
          ></v-text-field>
          <v-btn icon @click="dateHandler('next', 'year')">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-row>
      </template>
      <v-date-picker
        ref="datePicker"
        :max="allowMaxDate"
        :min="allowMinDate"
        :active-picker.sync="activePicker"
        :allowed-dates="allowedDates"
        v-model="date"
        full-width
        no-title
        @click:year="saveYear"
      ></v-date-picker>
    </v-menu>
  </div>
  <div v-else>
    <v-dialog ref="dialog" v-model="dateModal" :return-value.sync="date" width="290px">
      <template v-slot:activator="{ on, attrs }">
        <v-row class="align-center d-flex">
          <v-btn outlined color="btn_outline" class="outlined-btn" large width="92" @click="dateHandler('current', 'day')">
            <div class="d-flex align-center" style="gap:8px">
              <svg-icon icon-class="history" class="btn_text--text" />
              <span style="font-size:1rem" class="main_text--text">금일</span>
            </div>
          </v-btn>
          <v-btn icon @click="dateHandler('previous', 'day')">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-text-field
            :style="mobileTrigger ? 'width:40%' : 'width:20%'"
            v-model="displayDate"
            append-icon="$calendar"
            v-bind="attrs"
            v-on="on"
            readonly
            solo
            class="editor_bg"
            :clearable="clearable"
            @click:append="appendClick"
            @click:clear="onCleared"
          ></v-text-field>
          <v-btn icon @click="dateHandler('next', 'day')">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-row>
      </template>
      <v-date-picker
        ref="datePicker"
        v-model="date"
        :max="allowMaxDate"
        :min="allowMinDate"
        :allowed-dates="allowedDates"
        dense
        solo
        slot-scope
        scrollable
        no-title
        :disabled="disabled"
        @input="onSelectDate"
        :events="functionEvents"
        event-color="green lighten-1"
      ></v-date-picker>
    </v-dialog>
  </div>
</template>
<script>
import { getCurrentDate, getYearFormat, getPreDate, getProDate } from '@/utils/common.js'
export default {
  name: 'DateBar',
  props: {
    functionEvents: {
      type: Function,
      default: () => {}
    },
    label: {
      type: String,
      default: () => {
        return undefined
      }
    },
    dateOnly: {
      //datePicker만 사용할지
      type: Boolean,
      default: false
    },
    allowMaxDate: {
      //datePicker의 선택가능한 최대날짜 설정
      type: String,
      default: () => {
        return getYearFormat((parseInt(getCurrentDate()) + 5).toString())
      }
    },
    allowMinDate: {
      //datePicker의 선택가능한 최소날짜 설정
      type: String,
      default: () => {
        return '2020'
      }
    },
    firstDisplayDate: {
      //text-field에 표시하는 초기 display날짜 설정
      type: [String, Function],
      default: () => {
        return ''
      }
    },
    disabled: {
      //비활성화
      type: Boolean,
      default: false
    },
    year: {
      type: Boolean,
      default: false
    },
    allowedDates: {
      type: Function,
      default: null
    },
    clearable: {
      type: Boolean,
      default: false
    },
    showOneClick: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    date: '',
    dateModal: false,
    maxDate: '',
    minDate: '',
    displayDate: '',
    dateMenu: false,
    activePicker: null
  }),
  watch: {
    dateMenu(val) {
      val && setTimeout(() => (this.activePicker = 'YEAR'))
    },
    firstDisplayDate() {
      this.setFirstDisplayDate()
    }
  },
  computed: {
    mobileTrigger: function() {
      return window.innerWidth < 1920
    }
  },
  mounted() {
    // this.setMaxDate()
    // this.setMinDate()
    this.setFirstDisplayDate()
  },
  methods: {
    dateHandler(button, range) {
      if (range == 'year') {
        let today = getCurrentDate().substring(0, 4)
        if (button == 'previous') {
          let previousYear = this.displayDate - 1
          console.log('this.displayDate', typeof previousYear)
          this.$emit('getDate', previousYear)
          this.displayDate = previousYear
          this.$refs.menu1.save(previousYear)
        }
        if (button == 'next') {
          // 현재 년도면 return
          // if (this.displayDate == today) {
          //   return
          // }
          // nextYear가 String 값으로 들어가서 동작이 안됨.  Number 강제로 넣게 처리
          let nextYear = Number(this.displayDate) + 1 //this.displayDate + 1
          this.$emit('getDate', nextYear)
          this.displayDate = nextYear
          this.$refs.menu1.save(nextYear)
        }
        if (button == 'current') {
          this.$emit('getDate', today)
          this.displayDate = today
          this.$refs.menu1.save(today)
        }
      }
      if (range == 'day') {
        let currentDate = this.formatDate(this.displayDate)
        let today = getCurrentDate()
        if (button == 'previous') {
          let previousDate = getPreDate(currentDate)
          this.$emit('getDate', previousDate)
          this.displayDate = this.formatDate(previousDate)
          this.$refs.dialog.save(previousDate)
        }
        if (button == 'next') {
          if (today == currentDate) {
            return
          }
          let nextDate = getProDate(currentDate)
          this.$emit('getDate', nextDate)
          this.displayDate = this.formatDate(nextDate)
          this.$refs.dialog.save(nextDate)
        }
        if (button == 'current') {
          this.$emit('getDate', today)
          this.displayDate = this.formatDate(today)
          this.$refs.dialog.save(today)
        }
      }
      // if(this.$refs.datePicker != null){
      //   this.$refs.datePicker.tableDate = this.formatDate(this.displayDate)
      // }
    },
    appendClick() {
      this.dateModal = true
    },
    set() {
      this.$emit('getDate', this.date)
      // this.date = this.date + ' ' + this.time
      this.displayDate = this.formatDate(this.date)
      this.$refs.dialog.save(this.date)
    },
    setFirstDisplayDate() {
      if (this.firstDisplayDate != null && this.year) this.displayDate = getYearFormat(this.firstDisplayDate)
      else if (this.firstDisplayDate != null) this.displayDate = this.formatDate(this.firstDisplayDate)
      else this.displayDate = ''
    },
    formatDate(date) {
      if (!date) return null

      if (date.indexOf('-') > -1) {
        const [year, month, day] = date.split('-')
        return `${year}.${month}.${day}`
      }
      if (date.indexOf('.') > -1) {
        const [year, month, day] = date.split('.')
        return `${year}-${month}-${day}`
      }
    },
    onCleared() {
      this.date = null
      this.$emit('getDate', this.date)
      this.$refs.dialog.save(this.date)
    },
    onSelectDate(e) {
      this.$emit('getDate', this.date)
      // this.date = this.date + ' ' + this.time
      this.displayDate = this.formatDate(this.date)
      this.$refs.dialog.save(this.date)
    },
    saveYear(year) {
      this.date = `${year}-01`
      this.displayDate = year
      this.$refs.menu1.save(year)
      this.$emit('getDate', year)
    }
  }
}
</script>
<style scoped>
.outlined-btn {
  background-color: #fff;
  border-radius: 8px;
}
</style>
